import { Injectable } from '@angular/core'
import { Response, RequestOptionsArgs } from '@angular/http'
import { Angular2TokenService } from 'angular2-token'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of'

import { AppHttpBroadcaster } from './app-http.broadcaster'
import { IAppHttp } from './i-app-http'

@Injectable()
export class AppHttp extends IAppHttp {
  constructor(private tokenService: Angular2TokenService, private broadcaster: AppHttpBroadcaster) {
    super()
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.request('get', [url, options])
  }

  post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.request('post', [url, body, options])
  }

  patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.request('patch', [url, body, options])
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.request('delete', [url, options])
  }

  request(method, args: Array<any>): Observable<Response> {
    return Observable.create(observer => {
      this.tokenService[method](...args).subscribe(
        response => {
          observer.next(response)
          observer.complete()
        },
        error => {
          this.broadcaster.emitError(error)
          observer.error(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/http/app.http.ts